import { lazy } from 'react'
import reducer from './state/reducers'
import { getStore } from '@AppRedux/store'

const store = getStore();

const LoginScreen = lazy(() =>
    import('./LoginScreen').then(async module => {
        store.injectReducer('loginForm', reducer.loginReducer)
        return module
    })
);

const ApplicantDetail = lazy(() =>
    import('./ApplicantStatus').then(async module => {
        store.injectReducer('statusForm', reducer.statusReducer)
        return module
    })
);

export const routes = [
    {
        path: '/apply',
        component: LoginScreen,
        exact: true,
        public: true,
    },
    {
        label: 'Status Of Application',
        path: '/ApplicantStatus',
        component: ApplicantDetail,
        exact: true,
        public: true,
    },
]